import { memo } from "react";
import { Typography, Box } from "@mui/material";
import InspectorForm from "../../components/forms/InspectorForm.js";
import useCreateStyles from "../../components/styles/Create.js";

const CreateInspector = () => {
    const classes = useCreateStyles();
    return (
        <>
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    <Typography variant="h4" sx={{ margin: "1rem" }}>
                        Προσθήκη Ελεγκτή
                    </Typography>
                    <InspectorForm
                        isCreate={true}     
                    />
                </Box>
            </Box>
        </>
    )
}

export default memo(CreateInspector)